import { addMoneys, allAmountsSame, isNullOrUndefined, valueIsNotNullOrUndefined } from '@afterpay/utils'
import { useCheckoutState, useDonation, useIsExpress } from '../../state'
import { money } from '../../model'
import { Money } from '@afterpay/types'

const totalAmountPayable = (amount: string, currency, symbol?: string): Money => ({
  amount,
  currency,
  symbol,
})

export const useTotalAmountPayable = (orderBreakdownIsHidden: boolean = false): Money | undefined => {
  const { started, checkout } = useCheckoutState()
  const isExpressCheckout = useIsExpress()
  const { donationAmount } = useDonation()
  const initialAmount = checkout?.amount
  const finalAmount = started?.promotion?.owedAfterDiscount ?? started?.consumerAmount
  const currency = finalAmount?.currency
  const symbol = finalAmount?.symbol

  if (isNullOrUndefined(currency)) {
    return
  }

  const payableAmounts: Money[] = [finalAmount, money(donationAmount.toString(), currency)].filter(valueIsNotNullOrUndefined)
  const totalAmount = addMoneys({ moneys: payableAmounts })

  if (orderBreakdownIsHidden) {
    return totalAmountPayable(totalAmount, currency, symbol)
  }

  const initialAndFinalOrderAmounts = [initialAmount, finalAmount].filter(valueIsNotNullOrUndefined)
  const orderAmountIsUnchanged = allAmountsSame(initialAndFinalOrderAmounts) && donationAmount === 0
  if (!isExpressCheckout && orderAmountIsUnchanged) {
    return
  }

  return totalAmountPayable(totalAmount, currency, symbol)
}
